import { useAuth0 } from '@auth0/auth0-react';
import { PATHS } from 'routes/routes.constants';

import Button from '@polyai/ui/components/atoms/Button';
import { LogoutIcon } from '@polyai/ui/components/atoms/Icons';

import OTError from 'components/organisms/OTError/OTError';
import { useToast } from 'hooks/useToast';
import { OPENTABLE_ERROR_PAGE_UI_COPY } from './OpenTableErrorPage.uiCopy';

const OpenTableErrorPage = () => {
  const { logout } = useAuth0();
  const toast = useToast();

  const handleContactClick = async () => {
    await window.navigator.clipboard.writeText(
      OPENTABLE_ERROR_PAGE_UI_COPY.contactEmail,
    );
    toast.success({
      title: OPENTABLE_ERROR_PAGE_UI_COPY.contactToastTitle,
      description: OPENTABLE_ERROR_PAGE_UI_COPY.contactToastMessage,
    });
  };

  const performLogout = async () => {
    try {
      await logout({
        logoutParams: {
          federated: true,
          returnTo: `${window.location.origin}${PATHS.OPENTABLE_REGION}`,
        },
      });
    } catch (error) {
      console.error('Error during federated logout.', error);
    }
  };

  return (
    <OTError
      description={OPENTABLE_ERROR_PAGE_UI_COPY.errorMessage}
      title="Action required"
    >
      <div className="mt-sm3">
        {OPENTABLE_ERROR_PAGE_UI_COPY.contactMessage}
      </div>
      <div className="flex flex-row justify-between w-full mt-sm3 gap-xs2">
        <Button
          label="Contact PolyAI"
          variant="PRIMARY"
          onClick={handleContactClick}
          className="!px-md1 !py-xs2 flex-grow"
        />
        <Button
          label="Log out"
          variant="PRIMARY"
          endAdornment={LogoutIcon}
          onClick={performLogout}
          className="!px-md1 !py-xs2 flex-grow"
        />
      </div>
    </OTError>
  );
};

export default OpenTableErrorPage;
